import { useTranslation } from "react-i18next";
import React, { Fragment, useEffect, useRef, useState, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../functions/api";
import {
  TableCell,
  TableRow,
  TableBody,
  useMediaQuery,
  TableHead,
  Table,
  Paper,
  TableContainer,
  TextField,
  IconButton,
  Typography,
  enuItem,
  Button,
  Box,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Hidden,
  Autocomplete,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import { DateTextField, DateTimeTextField, TimeTextField, Zeitraum, istInteger, prec } from "../lib";
import { debounce } from "../../functions/debounce";
import Grid from "@mui/material/Grid";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { useMessage } from "../../context/message-context";
import { pad } from "../../functions/default";
import VisibilityIcon from "@mui/icons-material/Visibility";

import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import openFile from "../shared/functions/download";
import { useTheme } from "@mui/material/styles";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

function Reisekostenabrechnung(props) {
  const { t } = useTranslation();
  //Standardfelder
  const { accessToken, client, tws, element, program, lock } = props;
  const [aufwendungen, setAufwendungen] = useState([]);
  const [aufwendungenSteuertabelle, setAufwendungenSteuertabelle] = useState([]);
  const [startZeitpunkt, setStartZeitpunkt] = useState("");
  const [startDatum, setStartDatum] = useState("0000-00-00");
  const [startUhrzeit, setStartUhrzeit] = useState("00:00");
  const [tage, setTage] = useState([]);
  const theme = useTheme();
  const [endZeitpunkt, setEndZeitpunkt] = useState("");
  const [endDatum, setEndDatum] = useState("0000-00-00");
  const [endUhrzeit, setEndUhrzeit] = useState("00:00");
  const [zeitraum, setZeitraum] = useState("");
  const { showErrorMessage } = useMessage();
  const [ueberNachtung, setUebernachtung] = useState(false);
  const [orteSync, setOrteSync] = useState(false);
  const [shownDays, setShownDays] = useState([]);
  const [tageAufeinanderFolgend, setTageAufeinanderFolgend] = useState(true);
  // collapsedDays
  // setCollapsedDays
  useEffect(() => {
    init();
    // eslint-disable-next-line
  }, []);
  const mahlzeitenAbzug = {
    breakfast: 0.2,
    lunch: 0.4,
    dinner: 0.4,
  };

  useEffect(() => {
    if (program === "FORGEN") {
      return;
    } // init()
    let tage = [];
    element.felderAntworten?.map((antwortFeld) => {
      if (isNaN(parseInt(antwortFeld.key))) {
        if (antwortFeld.key === "startZeitpunkt") {
          setStartZeitpunkt(antwortFeld.antwort);
          setStartDatum(antwortFeld?.antwort?.substring(0, 10));
          setStartUhrzeit(antwortFeld?.antwort?.substring(11));
        }
        if (antwortFeld.key === "uebernachtung") {
          setUebernachtung(antwortFeld?.antwort);
        }
        if (antwortFeld.key === "endZeitpunkt") {
          setEndZeitpunkt(antwortFeld.antwort);
          setEndDatum(antwortFeld?.antwort?.substring(0, 10));
          setEndUhrzeit(antwortFeld?.antwort?.substring(11));
        }
      } else {
        tage.push(antwortFeld);
      }
    });

    // )
    // setTage([])
    setTage([...tage]);
    // eslint-disable-next-line
  }, [element]);

  useEffect(() => {
    let zeitraum = DatumsRechenFeld(startZeitpunkt, endZeitpunkt);
    if (zeitraum > 31) {
      showErrorMessage(t("Es können maximal 31 Tage auf einmal beantragt werden!"));
    }
    if (isNaN(zeitraum) === false && zeitraum < 31 && zeitraum > 0) {
      const anzStunden = DatumsRechenFeld(startZeitpunkt, endZeitpunkt);

      setZeitraum(anzStunden);
      calculateDayArray(anzStunden);
    }
    if (zeitraum < 0) {
      setTage([]);
    }
    // eslint-disable-next-line
  }, [startZeitpunkt, endZeitpunkt, ueberNachtung, zeitraum]);

  const getYYYMMDDdatum = (datum) => {
    let yyyy = datum.getFullYear();
    let mm = datum.getMonth() + 1; // Months start at 0!
    let dd = datum.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    return yyyy + "" + mm + "" + dd;
  };
  useEffect(() => {
    if (program === "PMURA3") {
      return;
    }
    let summe = 0;
    let summeSteuerfrei = 0;
    let summePauschal = 0;
    let summeSteuerpflOhnePauschal = 0;
    let summeSteuerpfl = 0;
    let sammelFelder = [];

    tage.forEach((tag) => {
      const aufwendungen = parseFloat(tag.aufwendungen);
      if (aufwendungen <= 0) {
        return;
      }
      const land = tag?.location?.value;

      const landSteuern = aufwendungenSteuertabelle.find((e) => e.key === land);

      const { steuerFrei, steuerFreiOhneKuerzung } = steuerBerechnen(tag, landSteuern);

      if (aufwendungen < steuerFrei) {
        summeSteuerfrei += aufwendungen;
      } else {
        summeSteuerfrei += steuerFrei;
        summeSteuerpflOhnePauschal += aufwendungen - steuerFrei;
        let rest = aufwendungen - steuerFrei;
        if (steuerFreiOhneKuerzung < rest) {
          summePauschal += steuerFreiOhneKuerzung;
          summeSteuerpfl += rest - steuerFreiOhneKuerzung;
        } else {
          summePauschal += rest;
        }
      }
      summe += aufwendungen;
    });
    sammelFelder.push({
      art: "E",
      typ: "12",
      antwort: startZeitpunkt,
      name: "Zeitpunkt Start",
      key: "startZeitpunkt",
    });

    // sammelFelder.push({
    //   art: "E",
    //   typ: "05",
    //   antwort: firstDayAnreise,
    //   name: "Erster Tag Anreise",
    //   key: "firstDayAnreise",
    // });
    sammelFelder.push({
      art: "E",
      typ: "12",
      antwort: endZeitpunkt,
      name: "Zeitpunkt Ende",
      key: "endZeitpunkt",
    });

    // sammelFelder.push({
    //   art: "E",
    //   typ: "05",
    //   antwort: lastDayAbreise,
    //   name: "Letzter Tag Abreise",
    //   key: "lastDayAbreise",
    // });
    sammelFelder.push({
      art: "E",
      typ: "05",
      antwort: ueberNachtung,
      name: "Letzter Tag Abreise",
      key: "uebernachtung",
    });

    let zwis2 = [];
    tage.map((tag) => {
      sammelFelder.push(tag);
    });
    element.STEUERFREI = summeSteuerfrei;
    element.STEUERPFLICHTIG_OHNE_PAUSCHAL = summeSteuerpflOhnePauschal;
    element.STEUERPFLICHTIG = summeSteuerpfl;
    element.PAUSCHAL_STEUERPFLICHTIG = summePauschal;

    element.antwort = summe;
    element.felderAntworten = sammelFelder;
    props.onChange(element.key, element, undefined);
  }, [tage, aufwendungenSteuertabelle, ueberNachtung]);

  function steuerBerechnen(tag, landSteuern) {
    let steuerFrei = 0;
    let steuerFreiOhneKuerzung = 0;
    const defaultResult = { steuerFrei: 0, steuerFreiOhneKuerzung: 0 };

    if (!landSteuern || !tag) {
      return defaultResult;
    }

    if (tag.stunden === "8") {
      steuerFrei = landSteuern?.achtStunden;
      steuerFreiOhneKuerzung = parseFloat(landSteuern?.achtStunden);
    } else if (tag.stunden === "24") {
      steuerFrei = landSteuern?.vierundzwanzigStunden;
      steuerFreiOhneKuerzung = parseFloat(landSteuern?.vierundzwanzigStunden);
    }

    if (tag.overnight === "1") {
      steuerFrei = parseFloat(steuerFrei) + parseFloat(landSteuern.uebernachten);
    }
    const abzug = Object.keys(mahlzeitenAbzug).reduce((acc, meal) => {
      if (tag[meal] === "1") {
        return acc + parseFloat(landSteuern.vierundzwanzigStunden) * mahlzeitenAbzug[meal];
      }
      return acc;
    }, 0);

    steuerFrei -= abzug;
    return {
      steuerFrei: parseFloat(steuerFrei.toFixed(2)),
      steuerFreiOhneKuerzung: parseFloat(steuerFreiOhneKuerzung.toFixed(2)),
    };
    // return parseFloat(steuerFrei.toFixed(2));
  }
  const calculateDayArray = (zeitraum) => {
    let zwis = zeitraum.toString().split(".");
    let gesamtStunden = zeitraum * 24;
    // let tage = zwis[0]
    let element = [];
    let zwisTage = [];
    const start = new Date(startZeitpunkt.replace("T", " "));
    let startYYYMMDD = getYYYMMDDdatum(start);
    let zwisDatum = new Date(startZeitpunkt.replace("T", " "));
    let ende = new Date(endZeitpunkt.replace("T", " "));
    let endYYYYMMDD = getYYYMMDDdatum(ende);

    for (let I = 0; getYYYMMDDdatum(zwisDatum) <= endYYYYMMDD; I++) {
      const yyyy = zwisDatum.getFullYear();
      let mm = zwisDatum.getMonth() + 1; // Months start at 0!
      let dd = zwisDatum.getDate();
      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;
      const stunden = berechneAngesetzteStunden(yyyy + "" + mm + "" + dd, startYYYMMDD, endYYYYMMDD, start, I);
      // var vergleichsDatum = start
      if (tage.length > 0 && tage.find((e) => e.key === yyyy + "" + mm + "" + dd)) {
        let zwischenWert = tage.find((e) => e.key === yyyy + "" + mm + "" + dd);
        zwischenWert["stunden"] = stunden;
        element = calcuLateZeile(zwischenWert);
        zwisTage.push();
      } else {
        var pausch = "";

        if (aufwendungen.length === 0) {
        }
        if (parseInt(stunden) >= 8) {
          pausch = aufwendungen[0]?.achtStunden;
        }
        if (parseInt(stunden) === 24) {
          pausch = aufwendungen[0]?.vierundzwanzigStunden;
        }
        element = {
          bez: dd + "." + mm + "." + yyyy,
          key: yyyy + "" + mm + "" + dd,
          location: aufwendungen.length === 0 ? null : { label: aufwendungen[0]?.bez, value: aufwendungen[0]?.key },
          pauschalen: pausch,
          aufwendungen: pausch,
          summe: pausch,
          breakfast: "",
          lunch: "",
          dinner: "",
          overnight: "",
          stunden: stunden,
        };
      }
      gesamtStunden = gesamtStunden - stunden;
      zwisTage.push(element);
      zwisDatum.setDate(zwisDatum.getDate() + 1);
    }
    setTage([...zwisTage]);
  };
  const berechneAngesetzteStunden = (datum, startYYYMMDD, endYYYYMMDD, start, I) => {
    let stunden = "";

    if (datum > startYYYMMDD && datum < endYYYYMMDD) {
      stunden = "24";
    }
    if (datum === startYYYMMDD) {
      if (ueberNachtung) {
        stunden = "8";
        return stunden;
        // gesamtStunden = gesamtStunden - 16;
      }
    }
    if (datum === endYYYYMMDD) {
      if (ueberNachtung === true) {
        stunden = "8";
        return stunden;
      }
    }
    if (tageAufeinanderFolgend) {
      if (parseFloat(zeitraum * 24) <= 8) {
        stunden = "0";
      } else {
        const stunden1 = parseInt(startUhrzeit.split(":")[0]);
        const minuten1 = parseInt(startUhrzeit.split(":")[1]);
        const ersterTagMinuten = 24 * 60 - (stunden1 * 60 + minuten1);
        const stunden2 = parseInt(endUhrzeit.split(":")[0]);
        const minuten2 = parseInt(endUhrzeit.split(":")[1]);
        const zweiterTagMinuten = stunden2 * 60 + minuten2;
        if (startYYYMMDD === endYYYYMMDD) {
          if (parseInt(zeitraum * 24) >= 8) {
            stunden = "8";
          }
        } else {
          if (datum === startYYYMMDD) {
            if (ersterTagMinuten > zweiterTagMinuten || ersterTagMinuten === zweiterTagMinuten) {
              if (parseInt(zeitraum * 24) >= 24) {
                // stunden = "24";
                stunden = "8";
              } else {
                stunden = "8";
              }
            } else {
              stunden = "0";
            }
          }
          if (datum === endYYYYMMDD) {
            if (zweiterTagMinuten > ersterTagMinuten) {
              if (parseInt(zeitraum * 24) >= 24) {
                // stunden = "24";
                stunden = "8";
              } else {
                stunden = "8";
              }
            } else {
              stunden = "0";
            }
          }
        }
      }
    }
    return stunden;
  };
  const init = () => {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: program,
      statement: "REISEKOSTEN_INIT",
    };
    apiRequest("POST", "daten", payload, headers, initCB, setRedirect);
  };
  const initCB = (response) => {
    if (element?.inhalt?.spesenVorgaben) {
      let zwis = response.data.aufwendungen.map((e) => {
        const globalVorgabe = element.inhalt.spesenVorgaben.find((v) => v.key === "ALLE");
        const vorgabe = element.inhalt.spesenVorgaben.find((v) => v.key === e.key);

        return getVorgaben(e, vorgabe, globalVorgabe);
        if (vorgabe) {
          return vorgabe;
        } else {
          return globalVorgabe
            ? {
                key: e.key,
                bez: e.bez,
                vierundzwanzigStunden: globalVorgabe.vierundzwanzigStunden === "SKIP" ? e.vierundzwanzigStunden : globalVorgabe.vierundzwanzigStunden,
                achtStunden: globalVorgabe.achtStunden === "SKIP" ? e.achtStunden : globalVorgabe.achtStunden,
                uebernachten: globalVorgabe.uebernachten === "SKIP" ? e.uebernachten : globalVorgabe.uebernachten,
              }
            : e;
        }
      });
      setAufwendungen(zwis);
    } else {
      setAufwendungen(response.data.aufwendungen);
    }
    setAufwendungenSteuertabelle(response.data.aufwendungen);
  };
  const getVorgaben = (standard, vorgabe, globalVorgabe) => {
    //Wirkt erstmal ziemlich dämlich. Ist es eventuell auch....
    //Hier werden aus standard,vorgabe und globalvorgabe die Werte "berechnet"
    //Reihenfolge der Wirksamkeit vorgabe<globalVorgabe<standard.
    // Wenn in einem der Werte Skip steht, wird auf den in der nächsten Stufe zurückgegriffen usw.
    //PE
    if (vorgabe) {
      if (globalVorgabe) {
        return {
          key: standard.key,
          bez: standard.bez,
          vierundzwanzigStunden:
            vorgabe.vierundzwanzigStunden !== "SKIP"
              ? vorgabe.vierundzwanzigStunden
              : globalVorgabe.vierundzwanzigStunden !== "SKIP"
                ? globalVorgabe.vierundzwanzigStunden
                : standard.vierundzwanzigStunden,
          achtStunden:
            vorgabe.achtStunden !== "SKIP" ? vorgabe.achtStunden : globalVorgabe.achtStunden !== "SKIP" ? globalVorgabe.achtStunden : standard.achtStunden,
          uebernachten:
            vorgabe.uebernachten !== "SKIP" ? vorgabe.uebernachten : globalVorgabe.uebernachten !== "SKIP" ? globalVorgabe.uebernachten : standard.uebernachten,
        };
      } else {
        return {
          key: standard.key,
          bez: standard.bez,
          vierundzwanzigStunden: vorgabe.vierundzwanzigStunden !== "SKIP" ? vorgabe.vierundzwanzigStunden : standard.vierundzwanzigStunden,
          achtStunden: vorgabe.achtStunden !== "SKIP" ? vorgabe.achtStunden : standard.achtStunden,
          uebernachten: vorgabe.uebernachten !== "SKIP" ? vorgabe.uebernachten : standard.uebernachten,
        };
      }
    }
    if (globalVorgabe) {
      return {
        key: standard.key,
        bez: standard.bez,
        vierundzwanzigStunden: globalVorgabe.vierundzwanzigStunden !== "SKIP" ? globalVorgabe.vierundzwanzigStunden : standard.vierundzwanzigStunden,
        achtStunden: globalVorgabe.achtStunden !== "SKIP" ? globalVorgabe.achtStunden : standard.achtStunden,
        uebernachten: globalVorgabe.uebernachten !== "SKIP" ? globalVorgabe.uebernachten : standard.uebernachten,
      };
    }
    return standard;
  };
  const setRedirect = (path) => {
    navigate(path);
  };
  function DatumsRechenFeld(von, bis) {
    // var inhalt = SubFelder(tmpinhalt, gruppe, ind)
    return getDaysBetweenDates(von?.replace("T", " "), bis?.replace("T", " "));
  }

  const getDateValue = () => {
    let zwis = zeitraum.toString().split(".");
    let tage = zwis[0];
    if (tage === "") {
      tage = "0";
    }
    tage = parseInt(tage) < 9 ? "0" + tage : tage;

    let stunden = 0;
    if (zwis[1] === undefined) {
      stunden = "0";
    } else {
      stunden = Math.floor(("0." + zwis[1]) * 24);
    }
    stunden = parseInt(stunden) < 9 ? "0" + stunden : stunden;
    return tage + ":" + stunden;
  };
  const calcuLateZeile = (zeile) => {
    let zeitraum = DatumsRechenFeld(startZeitpunkt, endZeitpunkt);
    if (zeile.location === undefined || zeile.location === null) {
      return zeile;
    }
    let ort = aufwendungen.find((e) => e.key === zeile["location"].value);
    let ortAbzug = aufwendungenSteuertabelle.find((e) => e.key === zeile["location"].value);
    if (ort === undefined) return zeile;
    let summeAufwendungen = 0;

    if (parseInt(zeile["stunden"]) >= 8) {
      summeAufwendungen = parseInt(ort.achtStunden);
    }
    if (parseInt(zeile["stunden"]) === 24) {
      summeAufwendungen = parseInt(ort.vierundzwanzigStunden);
    }
    if (zeile["overnight"] === "1") {
      summeAufwendungen = summeAufwendungen + parseInt(ort.uebernachten);
    }
    let abzug = 0;
    if (zeile["breakfast"] === "1") abzug = parseFloat(parseInt(ortAbzug.vierundzwanzigStunden) * 0.2).toFixed(2);
    if (zeile["lunch"] === "1") abzug = parseFloat(parseInt(ortAbzug.vierundzwanzigStunden) * (0.4).toFixed(2) + parseFloat(abzug)).toFixed(2);
    if (zeile["dinner"] === "1") abzug = parseFloat(parseInt(ortAbzug.vierundzwanzigStunden) * (0.4).toFixed(2) + parseFloat(abzug)).toFixed(2);
    if (zeile["VMA_RAUS"] === "1") {
      abzug = 0;
      summeAufwendungen = 0;
    }
    zeile["pauschalen"] = summeAufwendungen.toString();
    zeile["abzug"] = abzug;
    zeile["aufwendungen"] =
      parseFloat(parseInt(summeAufwendungen) - parseFloat(abzug)).toFixed(2) < 0 ? 0 : parseFloat(parseInt(summeAufwendungen) - parseFloat(abzug)).toFixed(2);

    return zeile;
  };
  useEffect(() => {
    setStartZeitpunkt(startDatum + "T" + startUhrzeit);
    const tageUnterschied = checkAufeinanderFolgendeTage(startDatum, endDatum);

    setTageAufeinanderFolgend(tageUnterschied < 2);
    if (!ueberNachtung && tageUnterschied > 1) {
      setUebernachtung(true);
    }
    if (ueberNachtung && tageUnterschied === 0) {
      setUebernachtung(false);
    }
    // updateElement("start", startUhrzeit, startDatum)
  }, [startUhrzeit, startDatum]);

  useEffect(() => {
    setEndZeitpunkt(endDatum + "T" + endUhrzeit);
    const tageUnterschied = checkAufeinanderFolgendeTage(startDatum, endDatum);
    setTageAufeinanderFolgend(tageUnterschied < 2);
    if (!ueberNachtung && tageUnterschied > 1) {
      setUebernachtung(true);
    }
    if (ueberNachtung && tageUnterschied === 0) {
      setUebernachtung(false);
    }
    // setUebernachtung(!(tageUnterschied < 2));
  }, [endUhrzeit, endDatum]);

  const checkAufeinanderFolgendeTage = (datum1, datum2) => {
    if (datum1 === "0000-00-00") return 0;
    if (datum2 === "0000-00-00") return 0;
    const date1 = new Date(datum1);
    const date2 = new Date(datum2);

    const tagUnterschied = Math.abs((date2 - date1) / (1000 * 60 * 60 * 24));

    return tagUnterschied;
  };
  const updateElement = useCallback(
    debounce((art, zeit, datum) => {
      if (art === "start") {
        setStartZeitpunkt(datum + "T" + zeit);
      }
      if (art === "ende") {
        setEndZeitpunkt(datum + "T" + zeit);
      }
    }, 500),
    [],
  );

  const changeWerte = (index, was, value, syncLauf) => {
    if (value === true) value = "1";
    if (value === false) value = "0";
    let zwis = tage;
    zwis[index][was] = value;
    if (was === "location" && orteSync && syncLauf !== "1") {
      zwis.forEach((tag, count) => {
        if (zwis[count]) {
          changeWerte(count, "location", value, "1");
          // zwis[count].location = value;
        }
      });
    }
    if (zwis[index]["location"] === null) {
      zwis[index]["pauschalen"] = "0";
      zwis[index]["abzug"] = "0";
      zwis[index]["aufwendungen"] = "0";
      setTage([...zwis]);
      return;
    }
    if (zwis[index]["VMA_RAUS"] === "1") {
      zwis[index]["pauschalen"] = "0";
      zwis[index]["abzug"] = "0";
      zwis[index]["aufwendungen"] = "0";
      setTage([...zwis]);
      return;
    }
    if (was === "VMA_RAUS" && value === "1") {
      zwis[index]["pauschalen"] = "0";
      zwis[index]["abzug"] = "0";
      zwis[index]["aufwendungen"] = "0";
      setTage([...zwis]);
      return;
    }
    let ort = aufwendungen.find((e) => e.key === zwis[index]["location"].value);
    let ortAbzug = aufwendungenSteuertabelle.find((e) => e.key === zwis[index]["location"].value);

    if (ort === undefined) return;
    let summeAufwendungen = 0;
    if (zeitraum < 1) {
      let stunden = Math.floor(zeitraum * 24);
      if (stunden < 8) {
        summeAufwendungen = 0;
      } else {
        summeAufwendungen = parseInt(ort.achtStunden);
      }
    } else if (zeitraum === 1) {
      summeAufwendungen = parseInt(ort.vierundzwanzigStunden);
    } else {
      if (parseInt(zwis[index]["stunden"]) >= 8) {
        summeAufwendungen = parseInt(ort.achtStunden);
      }
      if (parseInt(zwis[index]["stunden"]) === 24) {
        summeAufwendungen = parseInt(ort.vierundzwanzigStunden);
      }
    }
    if (zwis[index]["overnight"] === "1") {
      summeAufwendungen = parseFloat(summeAufwendungen + parseInt(ort.uebernachten)).toFixed(2);
    }
    let abzug = 0;
    if (zwis[index]["breakfast"] === "1") abzug = parseFloat(parseInt(ortAbzug.vierundzwanzigStunden) * 0.2).toFixed(2);
    if (zwis[index]["lunch"] === "1") abzug = parseFloat(parseInt(ortAbzug.vierundzwanzigStunden) * 0.4 + parseFloat(abzug)).toFixed(2);
    if (zwis[index]["dinner"] === "1") abzug = parseFloat(parseInt(ortAbzug.vierundzwanzigStunden) * (0.4).toFixed(2) + parseFloat(abzug)).toFixed(2);
    zwis[index]["pauschalen"] = summeAufwendungen.toString();
    zwis[index]["abzug"] = abzug;
    zwis[index]["aufwendungen"] = parseFloat(summeAufwendungen - abzug).toFixed(2) < 0 ? 0 : parseFloat(summeAufwendungen - abzug).toFixed(2);
    setTage([...zwis]);
  };
  function getDaysBetweenDates(d0, d1) {
    var msPerDay = 8.64e8;
    var x0 = new Date(d0);
    var x1 = new Date(d1);
    return (((x1 - x0) / msPerDay) * 1000) / 100;
  }

  const tage_zeichnen = tage.map((tag, count) => {
    return (
      <Fragment>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Typography variant="h5">{tag.bez}</Typography>
          <IconButton
            disabled={lock}
            onClick={(e) => {
              if (shownDays.includes(tag)) {
                setShownDays(shownDays.filter((day) => day !== tag));
              } else {
                setShownDays([...shownDays, tag]);
              }
            }}
          >
            {!shownDays.includes(tag) ? <VisibilityOffIcon size="small" /> : <VisibilityIcon />}
          </IconButton>
        </div>
        <TableRow style={{ display: "inline-block" }} key={tag + count}>
          {!shownDays.includes(tag) ? (
            <TableCell>
              <div style={{ display: "flex", spacing: "1" }}>
                <TextField
                  disabled
                  label="Pauschalen "
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={tage[count]["pauschalen"]}
                />
                <TextField
                  disabled
                  label="Abzug "
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={tage[count]["abzug"]}
                />
                <TextField
                  disabled
                  label="Summe "
                  variant="filled"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={tage[count]["aufwendungen"] < 0 ? 0 : tage[count]["aufwendungen"]}
                />
              </div>
            </TableCell>
          ) : (
            <TableCell width={"100%"}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tage[count]["VMA_RAUS"] === "1"}
                      disabled={lock}
                      onChange={(event) => changeWerte(count, "VMA_RAUS", event.target.checked)}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  }
                  label={element?.inhalt?.nameFuerPauschSpalte ? element?.inhalt?.nameFuerPauschSpalte : t("Pauschale bereits ausgezahlt")}
                />
              </FormGroup>

              <Autocomplete
                onChange={(event, newValue) => {
                  changeWerte(count, "location", newValue);
                }}
                options={aufwendungen?.map((ort) => ({
                  label: ort.bez,
                  value: ort.key,
                }))}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                disabled={lock}
                value={tage[count]["location"]}
                fullWidth
                label="Ort"
                renderInput={(params) => <TextField {...params} label="Reiseort" placeholder="Suchen" />}
              />
              <Typography align="center">{t("Erhaltene Mahlzeiten")}</Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tage[count]["breakfast"] === "1"}
                      disabled={lock}
                      onChange={(event) => changeWerte(count, "breakfast", event.target.checked)}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  }
                  label="Frühstück erhalten"
                />
              </FormGroup>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tage[count]["lunch"] === "1"}
                      disabled={lock}
                      onChange={(event) => changeWerte(count, "lunch", event.target.checked)}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  }
                  label="Mittagessen erhalten"
                />
              </FormGroup>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tage[count]["dinner"] === "1"}
                      disabled={lock}
                      onChange={(event) => changeWerte(count, "dinner", event.target.checked)}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  }
                  label="Abendessen erhalten"
                />
              </FormGroup>

              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tage[count]["overnight"] === "1"}
                      disabled={lock}
                      onChange={(event) => changeWerte(count, "overnight", event.target.checked)}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  }
                  label={element?.inhalt?.nameFueruUebernachtungSpalte ? element?.inhalt?.nameFueruUebernachtungSpalte : t("Auf eigene Kosten übernachtet")}
                />
              </FormGroup>
              <FormGroup>
                <TextField
                  disabled
                  label="Pauschalen"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={tage[count]["pauschalen"]}
                />
                <TextField
                  disabled
                  label="Mahlzeiten abzug "
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={tage[count]["abzug"]}
                />
                <TextField
                  disabled
                  label="Summe "
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={tage[count]["aufwendungen"] < 0 ? 0 : tage[count]["aufwendungen"]}
                />
              </FormGroup>
            </TableCell>
          )}
        </TableRow>
      </Fragment>
    );
  });

  const tage_zeichnenDesktop = tage.map((tag, count) => {
    return (
      <Fragment>
        <TableRow style={{ cursor: "pointer" }} key={tag + count}>
          <TableCell>{tag.bez}</TableCell>
          <TableCell align="center">
            {" "}
            <Checkbox
              checked={tage[count]["VMA_RAUS"] === "1"}
              disabled={lock}
              onChange={(event) => changeWerte(count, "VMA_RAUS", event.target.checked)}
              inputProps={{ "aria-label": "controlled" }}
            />
          </TableCell>
          <TableCell width={"25%"} align="center">
            <Autocomplete
              onChange={(event, newValue) => {
                changeWerte(count, "location", newValue);
              }}
              options={aufwendungen?.map((ort) => ({
                label: ort.bez,
                value: ort.key,
              }))}
              disabled={lock}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              value={tage[count]["location"]}
              fullWidth
              renderInput={(params) => <TextField {...params} label="" placeholder="Suchen" />}
            />
          </TableCell>

          <TableCell align="center">
            <Checkbox
              checked={tage[count]["breakfast"] === "1"}
              disabled={lock}
              onChange={(event) => changeWerte(count, "breakfast", event.target.checked)}
              inputProps={{ "aria-label": "controlled" }}
            />
          </TableCell>
          <TableCell align="center">
            <Checkbox
              checked={tage[count]["lunch"] === "1"}
              disabled={lock}
              onChange={(event) => changeWerte(count, "lunch", event.target.checked)}
              inputProps={{ "aria-label": "controlled" }}
            />
          </TableCell>
          <TableCell align="center">
            <Checkbox
              checked={tage[count]["dinner"] === "1"}
              disabled={lock}
              onChange={(event) => changeWerte(count, "dinner", event.target.checked)}
              inputProps={{ "aria-label": "controlled" }}
            />
          </TableCell>
          <TableCell align="center">
            <Checkbox
              checked={tage[count]["overnight"] === "1"}
              disabled={lock}
              onChange={(event) => changeWerte(count, "overnight", event.target.checked)}
              inputProps={{ "aria-label": "controlled" }}
            />
          </TableCell>
          <TableCell align="center">
            <TextField
              disabled
              sx={{ pb: 1, width: "30%" }}
              label="Pauschalen "
              InputLabelProps={{
                shrink: true,
              }}
              value={tage[count]["pauschalen"]}
            />
            <TextField
              disabled
              label="Mahlzeiten abzug "
              sx={{ pb: 1, width: "30%" }}
              InputLabelProps={{
                shrink: true,
              }}
              value={tage[count]["abzug"] ? tage[count]["abzug"] : "0"}
            />
            <TextField
              disabled
              label="Summe "
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ pb: 1, width: "30%" }}
              value={tage[count]["aufwendungen"] < 0 ? 0 : tage[count]["aufwendungen"]}
            />
          </TableCell>
        </TableRow>
      </Fragment>
    );
  });

  //Rückgabe
  return (
    <>
      <Fragment>
        <Grid item xs={12} md={4}>
          <Typography align="left">Zeitpunkt Abreise</Typography>
        </Grid>
        <Grid item xs={12} md={8} align="left" spacing={2}>
          <div style={{ marginBottom: "6px" }}>
            <DateTextField
              marginBottom={2}
              size="small"
              label="Datum"
              disabled={lock}
              fullWidth
              onChange={(e) => setStartDatum(e.target.value)}
              value={startDatum}
            />
          </div>
          <TimeTextField
            value={startUhrzeit}
            label="Uhrzeit"
            onChange={(e) => setStartUhrzeit(e.target.value)}
            disabled={lock}
            variant="outlined"
            size="small"
            fullWidth
          ></TimeTextField>
          {/* <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={firstDayAnreise}
                  disabled={lock === true || startDatum === endDatum}
                  onChange={(e) => setFirstDayAnreise(e.target.checked)}
                />
              }
              labelPlacement=""
              label="Erster Tag war ein Anreisetag"
            />
          </FormGroup> */}
        </Grid>{" "}
        <Grid item xs={12} md={4}>
          <Typography align="left">Zeitpunkt Wiederankunft</Typography>
        </Grid>
        <Grid item xs={12} md={8} align="left">
          <div style={{ marginBottom: "6px" }}>
            <DateTextField size="small" label="Datum" disabled={lock} fullWidth onChange={(e) => setEndDatum(e.target.value)} value={endDatum} />
          </div>
          <TimeTextField
            value={endUhrzeit}
            size="small"
            label="Uhrzeit"
            disabled={lock}
            onChange={(e) => setEndUhrzeit(e.target.value)}
            variant="outlined"
            fullWidth
          ></TimeTextField>

          {/* <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={lock === true || startDatum === endDatum}
                  checked={lastDayAbreise}
                  onChange={(e) => setLastDayAbreise(e.target.checked)}
                />
              }
              labelPlacement=""
              label="Letzter Tag war ein Abreisetag"
            />
          </FormGroup> */}
        </Grid>
        <Grid item xs={12} md={4}>
          {/* <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={lock === true || startDatum === endDatum}
                  checked={lastDayAbreise}
                  onChange={(e) => setLastDayAbreise(e.target.checked)}
                />
              }
              labelPlacement=""
              label="Mit Übernachtung"
            />
          </FormGroup> */}
        </Grid>
        <Grid item xs={12} md={8} align="left">
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={lock === true || tageAufeinanderFolgend === false}
                  checked={ueberNachtung}
                  onChange={(e) => setUebernachtung(e.target.checked)}
                />
              }
              label="Mit Übernachtung"
            />
          </FormGroup>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography align="left">Reisezeit (Tage/Stunden)</Typography>
        </Grid>
        <Grid item xs={12} md={8} align="left">
          <TextField disabled fullWidth value={getDateValue()} />
        </Grid>
        {program !== "PMURA3" && (
          <Grid item xs={12} md={4}>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox disabled={lock} checked={orteSync} onChange={(e) => setOrteSync(e.target.checked)} />}
                label="Orte für alle Tage übernehmen"
              />
            </FormGroup>
          </Grid>
        )}
        <Box sx={{ display: { xs: "none", md: "none", lg: "none", xl: "block", width: "100%" } }}>
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="center">{t("Tag")}</TableCell>
                  <TableCell align="center">
                    {element?.inhalt?.nameFuerPauschSpalte ? element?.inhalt?.nameFuerPauschSpalte : t("Pauschale bereits ausgezahlt")}
                  </TableCell>
                  <TableCell align="center">{t("Ort")}</TableCell>
                  <TableCell align="center">{t("Frühstück")}</TableCell>
                  <TableCell align="center">{t("Mittagessen")}</TableCell>
                  <TableCell align="center">{t("Abendessen")}</TableCell>
                  <TableCell align="center">
                    {element?.inhalt?.nameFueruUebernachtungSpalte ? element?.inhalt?.nameFueruUebernachtungSpalte : t("Auf eigene Kosten übernachtet")}
                  </TableCell>
                  <TableCell align="center">{t("Verpflegungsmehraufwendungen")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody> {tage_zeichnenDesktop}</TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box sx={{ display: { xs: "block", sm: "block", md: "block", lg: "block", xl: "none", width: "100%" } }}>
          <Grid item xs={12}>
            <TableContainer>
              <Table stickyHeader>
                <TableHead sticky>
                  <TableRow>
                    <TableCell width={"100%"}>
                      <Typography variant="h5" align="center">
                        {t("Einzelne Tage")}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{tage_zeichnen}</TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <div style={{ margin: "10px" }} />
        </Box>
      </Fragment>
    </>
  );
}

export default Reisekostenabrechnung;
